import { useContext, useState } from 'react';
import { Box, Button } from '@mui/joy';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import { LayoutContext } from '../../context';
import { canUseManagement, normalizedPositions } from '../../cabinetAccess';
import ListDealBlock from './ListDealBlock';

export default function TeamDrawingWorkspace() {
  const { account } = useContext(LayoutContext);
  const [open, setOpen] = useState(false);
  if (!canUseManagement(account) && !normalizedPositions(account).includes('quality_master')) return null;
  return <Box sx={{ my: 2 }}>
    <Button variant="soft" onClick={() => setOpen(value => !value)} aria-expanded={open}
      endDecorator={<ExpandMoreRounded sx={{ transform: open ? 'rotate(180deg)' : 'none' }} />}>
      {open ? 'Скрыть чертежи команды' : 'Чертежи команды'}
    </Button>
    {open && <Box sx={{ mt: 2 }}><ListDealBlock initialScope="team" /></Box>}
  </Box>;
}